module.exports = __webpack_public_path__ + "static/media/house-damage.d392f721.svg";